module.exports = __webpack_public_path__ + "static/craft-public-relations-logo-c4a9cc0817e32126218bc3d8443965e0.jpeg";